import { EPaymentInitSource, EPaymentWidgetResultStatus } from '../../../../PaymentWidgetMicrofrontend';
import { TThunkAction } from '../../../../common/types/thunk';
import { checkPaymentStatus } from '../checkPaymentStatus';
import { processChangingCheckPaymentStatus, EPaymentStatusCheckType } from '../processChangingCheckPaymentStatus';

export const openPaymentModalThunk =
  (amount: number): TThunkAction =>
  async (dispatch, _, context) => {
    const { paymentWidgetMicrofrontend, config } = context;

    const paymentInitSource = config.getStrict<EPaymentInitSource>('paymentInitSource');

    const result = await paymentWidgetMicrofrontend!.openDepositModal({ amount, paymentInitSource });

    if (result.status === EPaymentWidgetResultStatus.Success) {
      dispatch(
        checkPaymentStatus({
          onChangePaymentStatus: processChangingCheckPaymentStatus(EPaymentStatusCheckType.Balance),
          paymentId: result.paymentId,
          provider: result.provider,
        }),
      );
    }
  };
